import { AfterViewInit, Component, input, output } from '@angular/core';
import { ImageRadioGroupModel } from '@shared/models/image-radio-group-model';
import { NgClass } from '@angular/common';

@Component({
  selector: 'image-radio-group',
  templateUrl: './image-radio-group.component.html',
  styleUrls: ['./image-radio-group.component.scss'],
  imports: [NgClass],
})
export class ImageRadioGroupComponent implements AfterViewInit {
  readonly options = input.required<ImageRadioGroupModel[]>();
  readonly emitEvent = input<boolean>(true);
  readonly identifier = input<string>('');
  readonly emitFunction = input<Function>();
  readonly valueChange = output<any>();
  selectedOption: ImageRadioGroupModel | undefined;

  changeValue(value: any) {
    const emitFunction = this.emitFunction();
    if (this.emitEvent()) {
      this.valueChange.emit(value);
    } else if (emitFunction) {
      emitFunction(value);
    }
  }

  ngAfterViewInit(): void {
    this.options().forEach(option => {
      if (option.selected) {
        this.selectedOption = option;
      }
    });
  }
}
